import axios from 'axios';
import { apiUrl } from './apiUrl';

export const getClientDiscounts = () =>
    axios.get(`${apiUrl}/discounts`)

export const getClientCoupons = () =>
    axios.get(`${apiUrl}/coupons`)

export const createClientCoupon = coupon =>
    axios.post(`${apiUrl}/coupons`, coupon)


// WEBPACK FOOTER //
// ./src/baseparking-api/Discounts.js